<template>
  <div
    class="files-container"
    :class="[{ loading: reloading }, { '': !reloading }]"
  >
    <div class="form">
      <label>{{ fieldName }}</label>
      <template v-if="everythingLoaded && getData.length > 0">
        <md-table v-model="getData">
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell
              md-label="Bestandsnaam"
              class="cursor-pointer"
              @click.native="downloadFile(item)"
              >{{ item.name }}</md-table-cell
            >
            <md-table-cell md-label="Aanmaak datum"
              >{{ formatDateTime(item.created_at) }}
            </md-table-cell>
            <md-table-cell md-label="Verwijderen">
              <div class="md-group">
                <md-button
                  class="md-just-icon md-danger md-simple"
                  @click.native="showSwal(item.id)"
                >
                  <md-icon>delete</md-icon>
                </md-button>
              </div>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </template>
      <label v-if="everythingLoaded && getData.length === 0"
        >Geen bestanden</label
      >
    </div>
    <user-edit-document-upload
      v-if="everythingLoaded"
      v-model="upload"
      :field-id="fieldId"
      label-picker="Document kiezen"
      label-upload="Document uploaden"
      :contentTypes="contentTypes"
    ></user-edit-document-upload>
  </div>
</template>
<script>
import UserEditDocumentUpload from "../Users/UserEditDocumentUpload.vue";
import swal from "sweetalert2";
import Fuse from "fuse.js";

export default {
  components: {
    UserEditDocumentUpload
  },
  props: ["fieldName", "fieldId", "contentTypes"],
  data() {
    return {
      loaded: {
        files: false
      },
      files: [],
      upload: null,
      reloading: false
    };
  },
  computed: {
    everythingLoaded: function() {
      for (let i in this.loaded) {
        if (!this.loaded[i]) {
          return false;
        }
      }

      return true;
    },
    getData: function() {
      return this.sortCollection(this.files, "created_at", "desc");
    }
  },
  methods: {
    downloadFile(item) {
      this.notifyVue(
        "Document '" + item.name + "' download gestart",
        "check",
        "success",
        5000
      );
      this.reloading = true;
      this.$http
        .get(
          this.$apiBaseUrl +
            "user/" +
            this.$route.params.id +
            "/file/" +
            this.fieldId +
            "/" +
            item.id,
          { responseType: "blob" }
        )
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fURL = document.createElement("a");

          fURL.href = fileURL;
          fURL.setAttribute("download", item.name);
          document.body.appendChild(fURL);
          fURL.click();
          document.body.removeChild(fURL);
          this.reloading = false;
        });
    },
    deleteFile(fileId) {
      this.$http
        .delete(
          this.$apiBaseUrl +
            "user/" +
            this.$route.params.id +
            "/file/" +
            this.fieldId +
            "/" +
            fileId
        )
        .then(
          response => {
            this.loadFiles();

            this.notifyVue(
              "Document succesvol verwijderd",
              "check",
              "success",
              5000
            );
          },
          response => {
            if (response.status === 403) {
              this.notifyVue(
                "U heeft geen rechten voor het verwijderen van dit document",
                "add_alert",
                "danger",
                0
              );
            }
          }
        );
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    },
    loadFiles() {
      this.reloading = true;
      this.$http
        .get(
          this.$apiBaseUrl +
            "user/" +
            this.$route.params.id +
            "/files/" +
            this.fieldId
        )
        .then(
          response => {
            this.files = response.data.files;
            this.loaded.files = true;
            this.reloading = false;
          },
          response => {
            if (response.status === 403) {
              this.notifyVue(
                "U heeft geen rechten voor het beheren van Chauffeur bestanden",
                "add_alert",
                "danger",
                0
              );
            }

            return [];
          }
        );
    },
    formatDateTime(dateTime) {
      if (typeof dateTime !== "string" || dateTime === "") {
        return dateTime;
      }
      dateTime = dateTime.split("T");
      dateTime[0] = dateTime[0].split("-");
      if (dateTime[0][0].length === 4) {
        dateTime[0] = dateTime[0].reverse();
      }
      dateTime[0] = dateTime[0].join("-");
      dateTime[1] = dateTime[1].substr(0, 8);

      return dateTime.join(" ");
    },
    showSwal(fileId) {
      swal
        .fire({
          title: "Waarschuwing!",
          text: "Weet u zeker dat u de wijzigingen wilt negeren?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Ja, document verwijderen",
          cancelButtonText: "Annuleren",
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.deleteFile(fileId);
          } else if (result.dismiss === swal.DismissReason.cancel) {
          }
        });
    }
  },
  watch: {
    upload() {
      this.loadFiles();
    }
  },
  mounted() {
    this.loadFiles();
  }
};
</script>
<style lang="scss">
.md-card .md-table-cell.cursor-pointer:not(:hover) {
  cursor: pointer;
}
div.files-container.loading .md-card .md-table-cell.cursor-pointer {
  cursor: wait !important;
}

.md-card .md-table-cell.cursor-pointer:hover {
  cursor: pointer;
  text-decoration: underline;
}

div.files-container {
  margin-bottom: 30px;

  &.loading {
    cursor: wait !important;
  }

  div.form {
    display: flex;
    flex-direction: row;

    label {
      min-width: 200px;
    }

    div.md-table {
      width: 90%;

      .md-table-cell:last-child .md-table-cell-container,
      .md-table-head:last-child {
        text-align: right !important;
        display: flex;
        justify-content: flex-end;
      }

      .md-table-cell:last-child .md-table-cell-container:hover,
      .md-table-head:last-child:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
